var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column gap-4"},[(_vm.hasPermission(8388608))?_c('MyResourceRequest'):_vm._e(),(_vm.hasPermission(16777216))?_c('ManageResourceRequest'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }